/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.offerings.create.lifecycle.modals.details.controllers', [
  'ui.bootstrap',
  'acme.common.service.rulesEngine'
])

  .controller('MembershipOfferingsCreateLifecycleModalsDetailsController', ['$scope', '$uibModalInstance', 'RulesEngineService', 'currentCategory', function($scope, $uibModalInstance, RulesEngineService, currentCategory) {

    $scope.membershipOfferingsCreateLifecycleModalsDetails = {

      model: {},

      findSelectedRuleAction: RulesEngineService.findSelectedRuleAction,

      init: function() {
        if (currentCategory) {
          this.model = currentCategory;
        }
      },

      done: function() {
        $uibModalInstance.close();
      },

      cancel: function() {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipOfferingsCreateLifecycleModalsDetails.init();

}]);